import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { mediaMaxTablet, PlusIcon } from '@root/shared/ui-kit'
import { ChevronLeftIcon } from '@root/shared/ui-kit'

import { supportDialogOnlineAtom, supportDialogScreenAtom } from '../atoms'

import { SupportIcon } from './support-icon'

import type { ClassNameProps } from '@root/shared/lib/react'

type SupportDialogHeadingProps = {
  onClose?: () => void
} & ClassNameProps

export const SupportDialogHeading: React.FC<SupportDialogHeadingProps> = ({
  className,
  onClose,
}) => {
  const { t } = useTranslation()
  const [online] = useAtom(supportDialogOnlineAtom)
  const [, setScreen] = useAtom(supportDialogScreenAtom)

  const handleBack = () => {
    setScreen({ screen: 'tickets' })
  }
  const handleCreateTicket = () => setScreen({ screen: 'create' })

  return (
    <Root className={className}>
      <ReturnIcon size={14} onClick={handleBack} />
      <SupportIcon online={online} style={{ width: 29 }} />
      <Title>{t('support.heading-brand')}</Title>
      <ButtonCreate
        size="h32"
        variant="secondary"
        radius="rounded"
        iconLeft={<PlusIcon />}
        onClick={handleCreateTicket}
      >
        {t('support.new-ticket')}
      </ButtonCreate>
      {onClose ? (
        <ButtonClose
          size="s"
          variant="ghost"
          iconRight={<CloseIcon />}
          onClick={onClose}
        />
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr auto auto;
  align-content: center;
  align-items: center;

  padding-inline-start: 14px;

  border-bottom: 1px solid var(--background-3);

  ${mediaMaxTablet(css`
    padding-inline-end: 14px;
  `)}
`

const Title = styled.div`
  color: var(--text-12);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  margin-inline-start: 6px;
`

const ButtonClose = styled(Button)`
  color: var(--text-9);

  &:hover {
    color: var(--text-12);
    background: transparent;
  }
`

const ReturnIcon = styled(ChevronLeftIcon)`
  color: var(--text-10);
  margin-inline: 4px 6px;
  cursor: pointer;
`

const ButtonCreate = styled(Button)`
  font-weight: 500;
  margin-block: 10px;
  margin-inline-end: 2px;
`
